<template>
  <div>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th scope="col">
            <a data-bs-toggle="collapse" :href="`#id-${competence.id}`">
              <div class="d-flex align-items-center">
                <i v-if="competence.children_data.length" class="fas fa-chevron-right mr-2"></i>
                {{ competence.name }}
                <i
                  v-if="competence.devicon"
                  style="margin-left: auto"
                  :class="`devicon-${competence.devicon}-plain colored`"
                ></i>
                <i
                  v-else
                  style="margin-left: auto"
                  :class="`devicon-${competence.name}-plain colored`"
                ></i>
              </div>
            </a>
          </th>
          <th scope="col">Candidates: {{ competence.total_candidates_count }}</th>
          <th scope="col">Job positions: {{ competence.total_jobads_count }}</th>
          <th scope="col">Icon name: {{ competence.devicon }}</th>
          <th class="text-right">
            <button data-toggle="modal" :href="`#edit-${competence.id}`" class="btn btn-link">
              <svgHelper class="edit" name="edit" />
            </button>

            <button
              data-toggle="modal"
              :href="`#subCompetenceModal-${competence.id}`"
              class="btn btn-link green"
            >
              <i class="fas fa-plus"></i>
            </button>

            <button
              style="color: #666;"
              class="btn btn-link"
              data-toggle="modal"
              :href="`#moveCompetenceModal-${competence.id}`"
            >
              <i class="fas fa-exchange-alt"></i>
            </button>

            <button
              class="btn btn-link"
              data-toggle="modal"
              :href="`#deleteModal-${competence.id}`"
            >
              <svgHelper name="delete"></svgHelper>
            </button>
          </th>
        </tr>
      </thead>
      <tbody class="collapse" :id="`id-${competence.id}`">
        <SubCompetence
          v-for="subCompetence in competence.children_data"
          :key="subCompetence.id"
          :subCompetence="subCompetence"
          :mainComp="competence"
          v-on:move="refreshCompetence()"
        />
      </tbody>
    </table>

    <!-- Sub competence modal -->
    <div
      class="modal fade"
      :id="`subCompetenceModal-${competence.id}`"
      tabindex="-1"
      aria-labelledby="subCompetenceModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="`subCompetenceModalLabels-${competence.id}`">
              Add Sub Competence
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeSub"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group m-label-left">
              <input
                class="form-control"
                id="name"
                type="text"
                :placeholder="competence.name"
                readonly
              />
              <label for="name">Main Competence Name</label>
            </div>
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="subCompetenceName"
                  type="text"
                  class="form-control"
                  id="subname"
                  name="competence"
                  placeholder="Sub competence name"
                />
                <label for="subname">Sub Competence Name</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="addSubCompetence(subCompetenceName, competence.id)"
              type="button"
              class="btn btn-primary"
            >
              Add
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End sub competence modal -->
    <div
      class="modal fade edit-modal"
      :id="`edit-${competence.id}`"
      tabindex="-1"
      aria-labelledby="editModal2"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="`editModal2Label-${competence.id}`">Edit Competence</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="">
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="editMainCompetenceName"
                  type="text"
                  class="form-control"
                  id="competence"
                  name="competence"
                />
                <label for="competence">Competence Name</label>
              </div>
              <div class="form-group flex-grow-1 m-label-left">
                <input
                  v-model="editCompetenceIcon"
                  type="text"
                  class="form-control"
                  id="icon"
                  name="competence"
                />
                <label for="icon">Competence Icon</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              @click="editCompetence(editMainCompetenceName, competence.id)"
              type="button"
              class="btn btn-primary"
            >
              Save changes
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade edit-modal"
      :id="`deleteModal-${competence.id}`"
      tabindex="-1"
      aria-labelledby="deleteModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Competence</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>
              Please confirm that you want to delete <strong>{{ competence.name }}</strong>
            </p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deleteCompetence(competence.id)" type="button" class="btn btn-primary">
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      :id="`moveCompetenceModal-${competence.id}`"
      tabindex="-1"
      aria-labelledby="moveCompetenceModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="subCompetenceModalLabels">Move competence</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeMove"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex align-items-center">
              <div class="form-group m-label-left" style="width: 100%">
                <v-select
                  v-model="selectedCompetence"
                  @search="getCompetences"
                  :options="competenceResults"
                  label="name"
                  :reduce="competence => competence"
                  :clearable="false"
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length >= 3">
                      No results found for <em>{{ search }}</em
                      >.
                    </template>
                    <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                  </template>
                </v-select>
                <label for="candidatew">Assign to parent competence</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="moveCompetence()" type="button" class="btn btn-primary">
              Confirm
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SubCompetence from './SubCompetenceItem';
export default {
  props: {
    competence: Object,
  },
  components: {
    SubCompetence,
  },
  data: () => ({
    subCompetenceName: '',
    editMainCompetenceName: '',
    editCompetenceIcon: '',
    competenceResults: [],
    selectedCompetence: '',
  }),

  methods: {
    refreshCompetence() {
      this.$emit('newcomp');
    },
    addSubCompetence(name, id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/create`, {
        method: 'post',
        data: {
          name: name,
          parent_id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$refs.closeSub.click();
          this.$emit('newcomp');
          this.$toasted.success('New sub-competence added successfully.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    editCompetence(name, id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/update`, {
        method: 'post',
        data: {
          name: name,
          devicon: this.editCompetenceIcon,
          competence_id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$emit('newcomp');
          this.$refs.close.click();
          this.$toasted.success('Competence successfully edited.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    deleteCompetence(id) {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/delete`, {
        method: 'delete',
        data: {
          competence_id: id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$emit('newcomp');
        this.$refs.closeDelete.click();
        this.$toasted.success('Competence deleted successfully.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
    getCompetences(search, loading) {
      loading(true);
      axios(`${process.env.VUE_APP_API_URL}/common/competence/all`, {
        method: 'post',
        data: {
          page: 1,
          count: 200000,
          search_word: search,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.competenceResults = response.data.data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },

    moveCompetence() {
      axios(`${process.env.VUE_APP_API_URL}/common/competence/update`, {
        method: 'post',
        data: {
          parent_id: this.selectedCompetence.id,
          competence_id: this.competence.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$refs.closeMove.click();
          this.refreshCompetence();
          this.$toasted.success('Competence moved successfully.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          this.$toasted.success(err.response.data, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
  },
  mounted() {
    this.editMainCompetenceName = this.competence.name;
    this.editCompetenceIcon = this.competence.devicon;
  },
};
</script>
<style lang="scss" scoped>
.green {
  padding-top: 12px;
  i {
    background: #5bb75b;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    color: #fff;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  text-decoration: none !important;
}
.edit {
  fill: #666;
}
</style>
